module.exports = __webpack_public_path__ + "static/media/widgetMinimap.f72fef12.svg";